import React from 'react';
import { Save, Loader2, RefreshCw } from 'lucide-react';

/**
 * SettingsHeader
 * 
 * Reusable header component for settings pages
 */
const SettingsHeader = ({
  title,
  description,
  onSave,
  onReset,
  isLoading,
  hasUnsavedChanges
}) => {
  return (
    <div className="rounded-box p-6 bg-base-100 border border-base-300">
      <div className="flex flex-col lg:flex-row justify-between gap-6">
        <div>
          <h1 className="text-4xl font-bold text-base-content">
            {title}
          </h1>
          <p className="text-base-content/60 mt-2">
            {description}
          </p>
        </div>
        <div className="flex items-center">
          <button
            onClick={onReset}
            className="btn btn-outline mr-3"
            disabled={isLoading}
          >
            {isLoading ? <Loader2 className="h-4 w-4 animate-spin" /> : <RefreshCw className="h-4 w-4" />}
            Reset
          </button>
          <button 
            type="button" 
            className="btn btn-primary"
            disabled={isLoading || !hasUnsavedChanges}
            onClick={onSave}
          >
            {isLoading ? (
              <>
                <Loader2 className="w-5 h-5 animate-spin mr-2" />
                Saving...
              </>
            ) : (
              <>
                <Save className="w-5 h-5 mr-2" />
                Save Settings
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettingsHeader; 